import React from 'react';

const DEFAULT_SOURCES = [
  ['scanner', 'Scanner B3'],
  ['reversal', 'Reversão na Tendência'],
  ['rsi2', 'RSI(2) Connors'],
  ['confluence', 'Kairi + Confluência'],
  ['setorial', 'Análise Setorial'],
];

export default function ConsolidatedSourcesStatus({ sources = DEFAULT_SOURCES, states = {} }) {
  return (
    <section aria-labelledby="consolidated-sources-title">
      <h2 id="consolidated-sources-title">Fontes consolidadas do scanner</h2>
      <p>O status de cada fonte é administrado aqui; a superfície principal permanece focada nos sinais.</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {sources.map(([key, label]) => {
          const state = states[key] || 'pending';
          const stateLabel = state === 'available' ? 'Disponível' : state === 'unavailable' ? 'Indisponível' : 'Aguardando';
          return (
            <span key={key} data-testid={`admin-source-status-${key}`} style={{ padding: '6px 9px', border: '1px solid rgba(148,163,184,.22)', borderRadius: 5 }}>
              <strong>{label}</strong> · {stateLabel}
            </span>
          );
        })}
      </div>
    </section>
  );
}